import queryString from 'query-string';

const objToQueryString = (obj) => {
    return queryString.stringify(obj)
}

export default objToQueryString;